import React, { useCallback } from 'react';

import styled from 'styled-components';

import notFound404Image from 'assets/images/illustrations/no-custom-permission-found.png';

import theme from 'constants/theme';

import { ButtonFilled } from 'uiToolkit/Button';
import { Typography11, Typography12 } from 'uiToolkit/Typography';

import { CUSTOM_ROLE_ACTION_TYPES, useCustomRoleContext } from './CustomRoleContext';

const StyledImage = styled.img`
  height: 160px;
  width: 420px;
  margin-top: 1rem;
  margin-bottom: 4rem;
`;

const Container = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const NoCustomPermissionScreen = () => {
  const { customRoleDispatch } = useCustomRoleContext();

  const openCreateNewRoleView = useCallback(() => {
    customRoleDispatch({
      type: CUSTOM_ROLE_ACTION_TYPES.openCreateNewView,
      payload: {},
    });
  }, [customRoleDispatch]);

  return (
    <Container>
      <StyledImage src={notFound404Image} />
      <Typography11 bottomGutter={1} weight={600} color={theme.palette.text.blackv1}>
        No Custom Access
      </Typography11>
      <Typography12 bottomGutter={3} color={theme.palette.grey.dark}>
        No custom permissions exists currently. You can create new permissions by clicking "Create Custom Access"
      </Typography12>
      <ButtonFilled width="294px" onClick={openCreateNewRoleView}>
        Create Custom Access
      </ButtonFilled>
    </Container>
  );
};

export default NoCustomPermissionScreen;
